// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2ERMj","content":"Consent_content__3ayqK","footer":"Consent_footer__3VLVg"};